module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e12-1b9d4f528503ab032f4e1926ae3375f6.jpg";